import {computed, ref, watch} from 'vue'
import {useStore} from 'vuex'
import deBounce from '../../foundation/js/deBounce'

const searchNow = deBounce((store,searchString)=>{
    store.dispatch('productSearch/resetSelectedFilters')
    if(searchString.length > 2){
        store.dispatch('productSearch/performStringSearch',{
            searchString: searchString
        })
        return false
    }
    if(searchString.length == 0){
        store.commit('productSearch/set_search_string', '')
        store.dispatch('productSearch/performStringSearch')
        return false;
    }
    
    store.commit('productSearch/set_search_string', searchString)
    store.commit('productSearch/set_products',[])
},500)

export default {
    name: 'SearchHeaer',
    setup() {
        const store = useStore()
        const shouldTriggerDebounce = ref(false)
        const searchString = computed({
            get: () => store.state.productSearch.search_string,
            set: (value) => {
                shouldTriggerDebounce.value = true
                store.commit('productSearch/set_search_string', value)
            }
        })

        const clearSearch = function(){
            store.commit('productSearch/set_search_string','')
            store.commit('productSearch/set_products',[])
            store.commit('productSearch/set_displayed_count', { displayedCount: 0 })
            store.commit('productSearch/set_search_result_max_count',0)
            store.dispatch('productSearch/resetSelectedFilters')
            store.dispatch('productSearch/performStringSearch')
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }
        
        watch(searchString,(newString)=>{
            if(!shouldTriggerDebounce.value)
                return
            shouldTriggerDebounce.value = false
            searchNow(store,newString)
        })

        return {
            searchString,
            getLabel,
            clearSearch,
        }
    },
}